import React from "react";
import MarkdownPage from "../components/MarkdownPage";

function ProfileCV() {
  return <MarkdownPage markdownPath="/markdown/profilecv.md" />;
}

export default ProfileCV;
